module.exports = __webpack_public_path__ + "img/vip-banner-bg.5f70b040.png";